export const Colors  = {
    JbgBlue: '#3F5072',
    
    // your colors
  }